module.exports = __webpack_public_path__ + "static/media/48_tn.94a69f24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/48_tn.jpg
// module id = 357
// module chunks = 0